export default class TableHeader {
    /**
     * A table header.
     *
     * @param {Object} props
     */
    constructor(props) {
        this.key = props.key;
        this.value = props.value;

        Object.assign(this, props);
    }
}
